import { Divider } from '@mantine/core';

export function DividerBlockView() {
  return <Divider my="xs" />;
}
